// import React, { useState, useEffect } from "react";
// import Base from "../../Config/Base";
// import { API_BASE_CRM_URL } from "../../Config/Config";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// // import { Select } from "antd";
// import AddStatus from "./AddStatus";
// import AddSource from "./AddSource";
// import "../../Config/swal.css";
// import { Input, Select, Button } from "antd";
// import { Footer } from "../footer/footer";

// const { TextArea } = Input;
// export default function AddLead() {
//   const [userDetails, SetUserDetails] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const userDetailsSession = JSON.parse(
//       sessionStorage.getItem("userDetails"),
//     );
//     SetUserDetails(userDetailsSession);
//   }, []);

//   useEffect(() => {
//     const userDetails = sessionStorage.getItem("userDetails");
//     if (!userDetails) {
//       navigate("/");
//     }
//   }, [navigate]);

//   const [loading, setLoading] = useState(false);
//   const [leadsStatusData, setLeadsStatusData] = useState([]);
//   const [leadSourceData, setLeadeSourceData] = useState([]);
//   const [leadAssignedToData, setLeadAssignedToData] = useState([]);
//   const [selectedSourceId, setSelectedSourceId] = useState("");
//   const [selectedStatusId, setSelectedStatusId] = useState("");

//   const [formValues, setFormValues] = useState({
//     Name: "",
//     Company: "",
//     Description: "",
//     Country: 1,
//     Zip: "",
//     City: "",
//     State: "",
//     Address: "",
//     Email: "",
//     Website: "",
//     PhoneNumber: "",
//     LeadValue: "",
//     Source: "",
//     Status: "",
//     Assigned: "",
//     LastContact: "",
//     DateAssigned: "",
//     ClientId: 0,
//     AddedFrom: userDetails.staffid,
//     Active: 1,
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeadSources`);
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         const data = await response.json();

//         if (data.Status) {
//           setLeadeSourceData(data.ResultData);
//         } else {
//           console.error("Fetched data is not an array:", data);
//           setLeadeSourceData([]); // Set an empty array to avoid errors
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeadStatus`);
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         const data = await response.json();

//         if (data.Status) {
//           setLeadsStatusData(data.ResultData);
//         } else {
//           console.error("Fetched data is not an array:", data);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const response = await fetch(
//           `${API_BASE_CRM_URL}staff/GetStaffDropdown`,
//         );
//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }
//         const data = await response.json();

//         if (data.Status) {
//           setLeadAssignedToData(data.ResultData);
//         } else {
//           console.error("Fetched data is not an array:", data);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const sourceOptions =
//     leadSourceData &&
//     leadSourceData.map((item) => ({
//       value: item.SourceId,
//       label: item.SourceName,
//     }));

//   const statusOptions =
//     leadsStatusData &&
//     leadsStatusData.map((item) => ({
//       value: item.id,
//       label: item.name,
//     }));

//   const assignedOptions =
//     leadAssignedToData &&
//     leadAssignedToData.map((item) => ({
//       value: item.staffid,
//       label: item.firstname,
//     }));

//   const handleSourceSelectChange = (selectedOption) => {
//     setSelectedSourceId(selectedOption);
//   };

//   const handleStatusSelectChange = (selectedOption) => {
//     setSelectedStatusId(selectedOption);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormValues((prevValues) => ({
//       ...prevValues,
//       [name]: value,
//     }));
//   };

//   const payload = {
//     name: formValues.Name,
//     company: formValues.Company,
//     description: formValues.Description,

//     country: 0,
//     zip: "",
//     city: formValues.City,
//     state: "",
//     address: formValues.Address,

//     assigned: userDetails.staffid,
//     status: selectedStatusId,
//     source: selectedSourceId,

//     lastcontact: new Date().toISOString().slice(0, 19).replace("T", " "),
//     dateassigned: new Date().toISOString().split("T")[0],

//     email: formValues.Email,
//     website: "",
//     phonenumber: formValues.PhoneNumber,

//     client_id: 0,
//     lead_value: 0,
//     active: 1,
//     addedfrom: userDetails.staffid,
//   };

//   const handleSubmit = async () => {
//     // e.preventDefault();
//     setLoading(true);

//     try {
//       const response = await fetch(`${API_BASE_CRM_URL}leads/AddLead`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const result = await response.json();

//       if (result.Status) {
//         setLoading(false);
//         Swal.fire({
//           title: `Lead Add Successfully.`,
//           icon: "success",
//           customClass: {
//             title: "swal-title",
//             content: "swal-text",
//           },
//         }).then((result) => {
//           if (result.isConfirmed || result.isDismissed) {
//             // window.location.reload();
//             navigate("/leads");
//           }
//         });
//       } else {
//         setLoading(false);
//         Swal.fire({
//           title: "Error",
//           text: "Failed to submit request.",
//           icon: "error",
//           customClass: {
//             title: "swal-title",
//             content: "swal-text",
//           },
//         });
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleNextProposal = () => {
//     navigate("/proposal/add");
//   };

//   return (
//     <>
//       <style>
//         {`
//         .ant-input-affix-wrapper,
// .ant-select-selector,
// .ant-input,
// .ant-input-number {
//   border-radius: 10px !important;
// }

// .ant-select-selector {
//   min-height: 40px !important;
//   display: flex !important;
//   align-items: center !important;
// }

// .ant-input-affix-wrapper {
//   padding: 8px 12px !important;
// }
//         `}
//       </style>
//       <Base>
//         <div className="page-heade mb-3">
//           <div className="d-flex justify-content-between align-items-center">
//             <div className="page-title">
//               <h4>Add Lead</h4>
//               <p className="fw-semibold">Fill out the form to add a new lead</p>
//             </div>

//             <div className="">
//               <Link to="/leads">
//                 <button className="btn btn-secondary btn-sm">
//                   <i className="fa-solid fa-list"></i>
//                 </button>
//               </Link>
//             </div>
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-xxl-12 col-xl-12">
//             <div className="card">
//               <div className="card-body p-1">
//                 <form onSubmit={handleSubmit}>
//                   <div className="row g-3 p-3">
//                     {/* Name */}
//                     <div className="col-12">
//                       <Input
//                         size="large"
//                         prefix={<i className="fa-solid fa-user"></i>}
//                         name="Name"
//                         value={formValues.Name}
//                         onChange={handleChange}
//                         placeholder="Enter Name *"
//                         required
//                       />
//                     </div>
//                     <div className="col-12">
//                       <Input
//                         size="large"
//                         prefix={<i className="fa-solid fa-phone"></i>}
//                         name="PhoneNumber"
//                         value={formValues.PhoneNumber}
//                         onChange={handleChange}
//                         placeholder="Enter Mobile Number *"
//                         required
//                       />
//                     </div>

//                     {/* Email */}
//                     <div className="col-12">
//                       <Input
//                         size="large"
//                         prefix={<i className="fa-solid fa-envelope"></i>}
//                         type="email"
//                         name="Email"
//                         value={formValues.Email}
//                         onChange={handleChange}
//                         placeholder="Enter Email"
//                       />
//                     </div>

//                     <div className="col-6">
//                       <Input
//                         size="large"
//                         prefix={<i className="fa-solid fa-building"></i>}
//                         name="Company"
//                         value={formValues.Company}
//                         onChange={handleChange}
//                         placeholder="Enter Company"
//                       />
//                     </div>

//                     {/* Source */}
//                     <div className="col-6">
//                       <Select
//                         size="large"
//                         showSearch
//                         placeholder="Select Source *"
//                         value={selectedSourceId || null}
//                         onChange={handleSourceSelectChange}
//                         filterOption={(input, option) =>
//                           (option?.label ?? "")
//                             .toLowerCase()
//                             .includes(input.toLowerCase())
//                         }
//                         options={sourceOptions}
//                         style={{ width: "100%" }}
//                       />
//                     </div>

//                     {/* Status */}
//                     <div className="col-6">
//                       <Select
//                         size="large"
//                         showSearch
//                         placeholder="Select Status *"
//                         value={selectedStatusId || null}
//                         onChange={handleStatusSelectChange}
//                         filterOption={(input, option) =>
//                           (option?.label ?? "")
//                             .toLowerCase()
//                             .includes(input.toLowerCase())
//                         }
//                         options={statusOptions}
//                         style={{ width: "100%" }}
//                       />
//                     </div>

//                     <div className="col-6">
//                       <Input
//                         size="large"
//                         prefix={<i className="fa-solid fa-city"></i>}
//                         name="City"
//                         value={formValues.City}
//                         onChange={handleChange}
//                         placeholder="City"
//                       />
//                     </div>

//                     <div className="col-12">
//                       <Input
//                         size="large"
//                         prefix={<i className="fa-solid fa-map-pin"></i>}
//                         name="Address"
//                         value={formValues.Address}
//                         onChange={handleChange}
//                         placeholder="Enter Address *"
//                         required
//                       />
//                     </div>

//                     {/* Description */}
//                     <div className="col-12">
//                       <TextArea
//                         rows={4}
//                         name="Description"
//                         value={formValues.Description}
//                         onChange={handleChange}
//                         placeholder="Enter Description"
//                       />
//                     </div>
//                   </div>

//                   <div className="d-flex justify-content-end gap-2 pb-3">
//                     {/* Save */}
//                     <div
//                       onClick={() => !loading && handleSubmit()}
//                       style={{
//                         width: "40px",
//                         height: "40px",
//                         background: "#fff",
//                         borderRadius: "8px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         cursor: loading ? "not-allowed" : "pointer",
//                         boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
//                         transition: "0.2s",
//                       }}
//                       title="Save"
//                     >
//                       <i
//                         className={`fa-solid ${
//                           loading ? "fa-spinner fa-spin" : "fa-check"
//                         }`}
//                         style={{
//                           color: "#198754",
//                           fontSize: "16px",
//                         }}
//                       />
//                     </div>

//                     {/* Next Proposal */}
//                     <div
//                       onClick={handleNextProposal}
//                       style={{
//                         width: "40px",
//                         height: "40px",
//                         background: "#fff",
//                         borderRadius: "8px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         cursor: "pointer",
//                         boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
//                         transition: "0.2s",
//                       }}
//                       title="save & Next Proposal"
//                     >
//                       <i
//                         className="fa-solid fa-file-circle-plus"
//                         style={{
//                           color: "#1B2850",
//                           fontSize: "16px",
//                         }}
//                       />
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//         <AddStatus />
//         <AddSource />
//         <Footer></Footer>
//       </Base>
//     </>
//   );
// }

import React, { useState, useEffect, useRef } from "react";
import Base from "../../Config/Base";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AddStatus from "./AddStatus";
import AddSource from "./AddSource";
import "../../Config/swal.css";
import { Input, Select, Spin } from "antd";
import { Footer } from "../footer/footer";

const { TextArea } = Input;

export default function AddLead() {
  const [userDetails, SetUserDetails] = useState([]);
  const navigate = useNavigate();

  // Camera input reference

  const [loading, setLoading] = useState(false);

  const [leadsStatusData, setLeadsStatusData] = useState([]);
  const [leadSourceData, setLeadeSourceData] = useState([]);
  const [leadAssignedToData, setLeadAssignedToData] = useState([]);

  const [selectedSourceId, setSelectedSourceId] = useState("");
  const [selectedStatusId, setSelectedStatusId] = useState("");
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const [showCamera, setShowCamera] = useState(false);
  const [cameraStream, setCameraStream] = useState(null);
  const [extractingCard, setExtractingCard] = useState(false);

  const openCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: {
            ideal: "environment",
          },
        },
        audio: false,
      });

      setCameraStream(stream);
      setShowCamera(true);

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
        }
      }, 100);
    } catch (error) {
      console.error("Camera error:", error);

      Swal.fire({
        title: "Camera Access Required",
        text: "Please allow camera permission in your browser settings.",
        icon: "warning",
      });
    }
  };
  const capturePhoto = async () => {
    if (!videoRef.current) return;

    const video = videoRef.current;
    const canvas = canvasRef.current;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const context = canvas.getContext("2d");

    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    canvas.toBlob(
      async (blob) => {
        if (!blob) return;

        const file = new File([blob], "visiting-card.jpg", {
          type: "image/jpeg",
        });

        closeCamera();

        await extractVisitingCard(file);
      },
      "image/jpeg",
      0.9,
    );
  };

  const closeCamera = () => {
    if (cameraStream) {
      cameraStream.getTracks().forEach((track) => {
        track.stop();
      });
    }

    setCameraStream(null);
    setShowCamera(false);
  };

  const extractVisitingCard = async (file) => {
    setExtractingCard(true);
    setLoading(true);

    try {
      const formData = new FormData();

      formData.append("image", file);

      const response = await fetch(
        `${API_BASE_CRM_URL}ChatGpt/extract-visiting-card`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) {
        setLoading(false);

        throw new Error("Failed to process visiting card");
      }

      const result = await response.json();

      if (!result.Status || !result.Data) {
        setLoading(false);

        throw new Error(
          result.Message || "Unable to extract visiting card details",
        );
      }

      const data = result.Data;

      const phoneNumber =
        data.mobile || data.phonenumber || data.alternate_mobile || "";

      setFormValues((prevValues) => ({
        ...prevValues,
        Name: data.name || prevValues.Name,
        Company: data.company || prevValues.Company,
        PhoneNumber: phoneNumber || prevValues.PhoneNumber,
        Email: data.email || prevValues.Email,
        Website: data.website || prevValues.Website,
        Address: data.address || prevValues.Address,
        City: data.city || prevValues.City,
        State: data.state || prevValues.State,
        Country: data.country || prevValues.Country,
        Zip: data.zip || prevValues.Zip,

        Description: data.designation
          ? `Designation: ${data.designation}`
          : prevValues.Description,
      }));

      Swal.fire({
        title: "Visiting Card Scanned",
        text: "Lead details have been filled automatically.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Visiting card extraction error:", error);

      Swal.fire({
        title: "Unable to Scan Card",
        text: error.message,
        icon: "error",
      });
    } finally {
      setExtractingCard(false);
      setLoading(false);
    }
  };
  const [formValues, setFormValues] = useState({
    Name: "",
    Company: "",
    Description: "",
    Country: 5,
    Zip: "",
    City: "",
    State: "",
    Address: "",
    Email: "",
    Website: "",
    PhoneNumber: "",
    LeadValue: "",
    Source: "",
    Status: "",
    Assigned: "",
    LastContact: "",
    DateAssigned: "",
    ClientId: 0,
    AddedFrom: "",
    Active: 1,
  });

  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );

    SetUserDetails(userDetailsSession);

    if (userDetailsSession?.staffid) {
      setFormValues((prevValues) => ({
        ...prevValues,
        AddedFrom: userDetailsSession.staffid,
      }));
    }
  }, []);

  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");

    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  // ============================
  // GET LEAD SOURCES
  // ============================
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeadSources`);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.Status) {
          setLeadeSourceData(data.ResultData);
        } else {
          setLeadeSourceData([]);
        }
      } catch (error) {
        console.error("Error fetching lead sources:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ============================
  // GET LEAD STATUS
  // ============================
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeadStatus`);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.Status) {
          setLeadsStatusData(data.ResultData);
        }
      } catch (error) {
        console.error("Error fetching lead status:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // ============================
  // GET STAFF
  // ============================
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const response = await fetch(
          `${API_BASE_CRM_URL}staff/GetStaffDropdown`,
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.Status) {
          setLeadAssignedToData(data.ResultData);
        }
      } catch (error) {
        console.error("Error fetching staff:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const sourceOptions =
    leadSourceData &&
    leadSourceData.map((item) => ({
      value: item.SourceId,
      label: item.SourceName,
    }));

  const statusOptions =
    leadsStatusData &&
    leadsStatusData.map((item) => ({
      value: item.id,
      label: item.name,
    }));

  const assignedOptions =
    leadAssignedToData &&
    leadAssignedToData.map((item) => ({
      value: item.staffid,
      label: item.firstname,
    }));

  const handleSourceSelectChange = (selectedOption) => {
    setSelectedSourceId(selectedOption);
  };

  const handleStatusSelectChange = (selectedOption) => {
    setSelectedStatusId(selectedOption);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // ============================
  // ADD LEAD PAYLOAD
  // ============================
  const payload = {
    name: formValues.Name,
    company: formValues.Company,
    description: formValues.Description,

    country: formValues.Country || 5,
    zip: formValues.Zip || "",
    city: formValues.City,
    state: formValues.State || "",
    address: formValues.Address,

    assigned: userDetails?.staffid,
    status: selectedStatusId,
    source: selectedSourceId,

    lastcontact: new Date().toISOString().slice(0, 19).replace("T", " "),

    dateassigned: new Date().toISOString().split("T")[0],

    email: formValues.Email,
    website: formValues.Website || "",
    phonenumber: formValues.PhoneNumber,

    client_id: 0,
    lead_value: 0,
    active: 1,
    addedfrom: userDetails?.staffid,
  };

  // ============================
  // SUBMIT
  // ============================
  const handleSubmit = async () => {
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_CRM_URL}leads/AddLead`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result.Status) {
        setLoading(false);

        Swal.fire({
          title: "Lead Add Successfully.",
          icon: "success",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            navigate("/leads");
          }
        });
      } else {
        setLoading(false);

        Swal.fire({
          title: "Error",
          text: "Failed to submit request.",
          icon: "error",
          customClass: {
            title: "swal-title",
            content: "swal-text",
          },
        });
      }
    } catch (error) {
      console.error("Error:", error);

      Swal.fire({
        title: "Error",
        text: "Something went wrong while adding the lead.",
        icon: "error",
        customClass: {
          title: "swal-title",
          content: "swal-text",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  const handleNextProposal = () => {
    navigate("/proposal/add");
  };

  return (
    <>
      <style>
        {`
          .ant-input-affix-wrapper,
          .ant-select-selector,
          .ant-input,
          .ant-input-number {
            border-radius: 10px !important;
          }

          .ant-select-selector {
            min-height: 40px !important;
            display: flex !important;
            align-items: center !important;
          }

          .ant-input-affix-wrapper {
            padding: 8px 12px !important;
          }
        `}
      </style>

      <Base>
        {showCamera && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "#000",
              zIndex: 9999,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <video
              ref={videoRef}
              autoPlay
              playsInline
              muted
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />

            <canvas ref={canvasRef} style={{ display: "none" }} />

            <div
              style={{
                position: "absolute",
                bottom: "30px",
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              {/* Capture */}
              <button
                type="button"
                onClick={capturePhoto}
                style={{
                  width: "70px",
                  height: "70px",
                  borderRadius: "50%",
                  border: "5px solid #fff",
                  background: "#fff",
                  cursor: "pointer",
                }}
                title="Take Photo"
              >
                <i
                  className="fa-solid fa-camera"
                  style={{
                    fontSize: "25px",
                    color: "#1B2850",
                  }}
                ></i>
              </button>

              {/* Close */}
              <button
                type="button"
                onClick={closeCamera}
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  border: "none",
                  background: "#fff",
                  cursor: "pointer",
                  alignSelf: "center",
                }}
                title="Close Camera"
              >
                <i
                  className="fa-solid fa-xmark"
                  style={{
                    fontSize: "22px",
                    color: "#dc3545",
                  }}
                ></i>
              </button>
            </div>
          </div>
        )}
        {loading && (
          <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{
              zIndex: 1050,
              backdropFilter: "blur(4px)",
              backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
            }}
          >
            <Spin size="large" tip="Processing..." />
          </div>
        )}
        <div className="page-heade mb-3">
          <div className="d-flex justify-content-between align-items-center">
            <div className="page-title">
              <h4>Add Lead</h4>
              <p className="fw-semibold">Fill out the form to add a new lead</p>
            </div>

            <div className="d-flex gap-2 align-items-end">
              {/* Hidden camera input */}

              {/* Camera button */}
              <button
                type="button"
                onClick={openCamera}
                disabled={extractingCard}
                className="btn btn-primary btn-sm"
                title="Scan Visiting Card"
              >
                <i
                  className={`fa-solid ${
                    extractingCard ? "fa-spinner fa-spin" : "fa-camera"
                  }`}
                ></i>
              </button>

              {/* Lead list */}
              <Link to="/leads">
                <button className="btn btn-secondary btn-sm">
                  <i className="fa-solid fa-list"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xxl-12 col-xl-12">
            <div className="card">
              <div className="card-body p-1">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (!loading) {
                      handleSubmit();
                    }
                  }}
                >
                  <div className="row g-3 p-3">
                    {/* Name */}
                    <div className="col-12">
                      <Input
                        size="large"
                        prefix={<i className="fa-solid fa-user"></i>}
                        name="Name"
                        value={formValues.Name}
                        onChange={handleChange}
                        placeholder="Enter Name *"
                        required
                      />
                    </div>

                    {/* Phone */}
                    <div className="col-12">
                      <Input
                        size="large"
                        prefix={<i className="fa-solid fa-phone"></i>}
                        name="PhoneNumber"
                        value={formValues.PhoneNumber}
                        onChange={handleChange}
                        placeholder="Enter Mobile Number *"
                        required
                      />
                    </div>

                    {/* Email */}
                    <div className="col-12">
                      <Input
                        size="large"
                        prefix={<i className="fa-solid fa-envelope"></i>}
                        type="email"
                        name="Email"
                        value={formValues.Email}
                        onChange={handleChange}
                        placeholder="Enter Email"
                      />
                    </div>

                    {/* Company */}
                    <div className="col-6">
                      <Input
                        size="large"
                        prefix={<i className="fa-solid fa-building"></i>}
                        name="Company"
                        value={formValues.Company}
                        onChange={handleChange}
                        placeholder="Enter Company"
                      />
                    </div>

                    {/* Source */}
                    <div className="col-6">
                      <Select
                        size="large"
                        showSearch
                        placeholder="Select Source *"
                        value={selectedSourceId || null}
                        onChange={handleSourceSelectChange}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={sourceOptions}
                        style={{ width: "100%" }}
                      />
                    </div>

                    {/* Status */}
                    <div className="col-6">
                      <Select
                        size="large"
                        showSearch
                        placeholder="Select Status *"
                        value={selectedStatusId || null}
                        onChange={handleStatusSelectChange}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        options={statusOptions}
                        style={{ width: "100%" }}
                      />
                    </div>

                    {/* City */}
                    <div className="col-6">
                      <Input
                        size="large"
                        prefix={<i className="fa-solid fa-city"></i>}
                        name="City"
                        value={formValues.City}
                        onChange={handleChange}
                        placeholder="City"
                      />
                    </div>

                    {/* Address */}
                    <div className="col-12">
                      <Input
                        size="large"
                        prefix={<i className="fa-solid fa-map-pin"></i>}
                        name="Address"
                        value={formValues.Address}
                        onChange={handleChange}
                        placeholder="Enter Address *"
                        required
                      />
                    </div>

                    {/* Description */}
                    <div className="col-12">
                      <TextArea
                        rows={4}
                        name="Description"
                        value={formValues.Description}
                        onChange={handleChange}
                        placeholder="Enter Description"
                      />
                    </div>
                  </div>

                  {/* Bottom buttons */}
                  <div className="d-flex justify-content-end gap-2 pb-3">
                    {/* Save */}
                    <div
                      onClick={() => !loading && handleSubmit()}
                      style={{
                        width: "40px",
                        height: "40px",
                        background: "#fff",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: loading ? "not-allowed" : "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                        transition: "0.2s",
                      }}
                      title="Save"
                    >
                      <i
                        className={`fa-solid ${
                          loading ? "fa-spinner fa-spin" : "fa-check"
                        }`}
                        style={{
                          color: "#198754",
                          fontSize: "16px",
                        }}
                      />
                    </div>

                    {/* Next Proposal */}
                    <div
                      onClick={handleNextProposal}
                      style={{
                        width: "40px",
                        height: "40px",
                        background: "#fff",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
                        transition: "0.2s",
                      }}
                      title="Save & Next Proposal"
                    >
                      <i
                        className="fa-solid fa-file-circle-plus"
                        style={{
                          color: "#1B2850",
                          fontSize: "16px",
                        }}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <AddStatus />
        <AddSource />
        <Footer />
      </Base>
    </>
  );
}
